@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.header {
  background: var(--light-40);
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 96px;
  flex-wrap: wrap;
}

@media (min-width: $tabletPortraitMinWidth) {
  .header {
    padding: 32px;
  }
}

@media (min-width: $phoneMaxWidth) {
  .header {
    padding: 0;
    width: calc(100% - 192px);
    justify-content: space-between;
    min-height: unset;
    margin-top: 30px;
    margin-bottom: -12px;
  }
}
